var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("作業報告書提出")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [_vm._v("基本情報")]),
          _c(
            "template",
            { slot: "file" },
            [_c("info-link", { ref: "infolink", on: { onbus: _vm.sendData } })],
            1
          ),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box bdr0", attrs: { span: 20 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "buildingCdMbuildgpModel.blgsnmkj",
                              _vm.currentBascInfo
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業名")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box bdr0", attrs: { span: 20 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue("workName", _vm.currentBascInfo)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("発注No連番")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "purchaseOrderDetailIdModel.acceptOrderNoSeq",
                              _vm.currentBascInfo
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("報告書No")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box bdr0", attrs: { span: 8 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue("workNo", _vm.currentBascInfo)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業予定期間")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _vm.getFieldValue(
                        "planWorkStartDate",
                        _vm.currentBascInfo
                      ) &&
                      _vm.getFieldValue("planWorkEndDate", _vm.currentBascInfo)
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "planWorkStartDate",
                                    _vm.currentBascInfo
                                  )
                                ) +
                                " 〜 " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "planWorkEndDate",
                                    _vm.currentBascInfo
                                  )
                                ) +
                                " "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("作業実施期間")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _vm.getFieldValue(
                        "resultWorkStartDate",
                        _vm.currentBascInfo
                      ) &&
                      _vm.getFieldValue(
                        "resultWorkEndDate",
                        _vm.currentBascInfo
                      )
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "resultWorkStartDate",
                                    _vm.currentBascInfo
                                  )
                                ) +
                                " 〜 " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "resultWorkEndDate",
                                    _vm.currentBascInfo
                                  )
                                ) +
                                " "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "vab-collapse-info",
        { staticClass: "mt16" },
        [
          _c("template", { slot: "title" }, [_vm._v("前回報告情報")]),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("前回報告書No")]
                  ),
                  _c(
                    "vab-col",
                    {
                      class: _vm.read
                        ? "word_box bdr0"
                        : "word_box word_link bdr0",
                      attrs: { span: 20 },
                    },
                    [
                      _c("span", { on: { click: _vm.goPreReport } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFieldValue("reportNo", _vm.preBasicInfo)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("前回報告日")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "reportIdModel.createDate",
                              _vm.preBasicInfo
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("前回実施期間")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _vm.getFieldValue(
                        "resultWorkStartDate",
                        _vm.preBasicInfo
                      ) &&
                      _vm.getFieldValue("resultWorkEndDate", _vm.preBasicInfo)
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "resultWorkStartDate",
                                    _vm.preBasicInfo
                                  )
                                ) +
                                " 〜 " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "resultWorkEndDate",
                                    _vm.preBasicInfo
                                  )
                                ) +
                                " "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }